/**
 * banner(导航栏)
 */
export default {
	state: {
		business_key: '',
		nav_title: '',
		back_title: '',
		sflx_id: '',
		sf_mc_obj: { mc: '' },
		node_name: '',
		reportFormsFlag: '', // 菜单高亮控制变量
		needCreate: false,
	},
	getters: {},
	mutations: {
		setNeadCreate(state, need) {
			state.needCreate = need;
		},
		businessKeyChange(state, businessKey) {
			state.business_key = businessKey;
		},
		navTitleChange(state, title) {
			state.nav_title = title;
		},
		backTitleChange(state, title) {
			state.back_title = title;
		},
		navSflxIdChange(state, sflxId) {
			state.sflx_id = sflxId;
			if (window.localStorage) {
				localStorage.sflx_id = state.sflx_id;
			} else {
				console.log('不支持localStorage');
			}
		},
		navSflxIdInit(state) {
			if (window.localStorage && !state.sflx_id) {
				state.sflx_id = localStorage.sflx_id;
			} else {
				console.log('不支持localStorage');
			}
		},
		navNodeNameChange(state, sflxId) {
			state.node_name = sflxId;
			if (window.localStorage) {
				localStorage.node_name = state.node_name;
			} else {
				console.log('不支持localStorage');
			}
		},
		navNodeNameInit(state) {
			if (window.localStorage && !state.node_name) {
				state.node_name = localStorage.node_name;
			} else {
				console.log('不支持localStorage');
			}
		},
		navSFMCChange(state, payload) {
			state.sf_mc_obj = payload;
			if (window.localStorage) {
				localStorage.sf_mc_obj = JSON.stringify(state.sf_mc_obj);
			} else {
				console.log('不支持localStorage');
			}
		},
		navNodeNameInit(state) {
			if (window.localStorage && !state.node_name) {
				state.node_name = localStorage.node_name;
			} else {
				console.log('不支持localStorage');
			}
		},
		navSFMCChange(state, payload) {
			state.sf_mc_obj = payload;
			if (window.localStorage) {
				localStorage.sf_mc_obj = JSON.stringify(state.sf_mc_obj);
			} else {
				console.log('不支持localStorage');
			}
		},
		navSFMCInit(state) {
			if (window.localStorage && localStorage.sf_mc_obj && !state.sf_mc_obj) {
				state.sf_mc_obj = JSON.parse(localStorage.sf_mc_obj);
			} else {
				console.log('不支持localStorage');
				console.log('不支持localStorage');
			}
		},
		/* 报表菜单高亮 */
		setNavReportForms(state, payload) {
			state.reportFormsFlag = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.reportFormsFlag = JSON.stringify(state.reportFormsFlag);
			}
		},
		initNavReportForms(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.reportFormsFlag = JSON.parse(window.localStorage.reportFormsFlag);
			}
		},
	},
};
